export const COMPONENTS_CONFIGURATION_NAME = '@refx/ssci';
